var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',{staticClass:"wraper-class"},[_c('Navbar'),_c('router-view',{staticClass:"content-class"}),(_vm.loggedIn)?_c('Footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }